import fetch from "../fetch";

export default ({ dealCode }) =>
  fetch({ method: "DELETE", path: `/abs/deals/${dealCode}` });
